import React, { useEffect, useState } from "react";
import { Youtube, ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";
import VideoCard from "./VideoCard";

export default function LatestFromChannel() {
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get("/channel/latest?limit=3")
            .then((r) => setData(r.data))
            .catch(() => {});
    }, []);

    if (!data || !data.videos?.length) return null;

    return (
        <section
            data-testid="latest-from-channel"
            className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-10 lg:px-16 border-t border-tattva-ornament"
        >
            <div className="flex items-end justify-between flex-wrap gap-6 mb-14">
                <div>
                    <p className="text-[11px] uppercase tracking-[0.3em] text-tattva-muted mb-4 flex items-center gap-2">
                        <Youtube size={14} strokeWidth={1.6} /> Latest on YouTube
                    </p>
                    <h2 className="font-serif text-4xl lg:text-5xl tracking-tight text-tattva-ink">
                        Fresh from{" "}
                        <span className="italic text-tattva-terracotta">
                            The Spiritual Seeker
                        </span>
                    </h2>
                </div>
                <a
                    href={data.channel_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => {
                        e.preventDefault();
                        window.open(
                            data.channel_url,
                            "_blank",
                            "noopener,noreferrer",
                        );
                    }}
                    data-testid="visit-channel-link"
                    className="inline-flex items-center gap-2 text-sm uppercase tracking-[0.22em] text-tattva-ink hover:text-tattva-terracotta transition-colors cursor-pointer"
                >
                    Visit channel <ArrowUpRight size={16} />
                </a>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 md:gap-14">
                {data.videos.map((v) => (
                    <VideoCard
                        key={v.youtube_id}
                        video={{
                            id: v.youtube_id,
                            youtube_id: v.youtube_id,
                            title: v.title,
                            description: v.description || "",
                            category: "The Spiritual Seeker",
                            thumbnail: v.thumbnail,
                        }}
                    />
                ))}
            </div>
        </section>
    );
}
